import { makeBenefitsApi } from 'src/http/api/internal/internal-http';
import { FairsRepository } from 'src/repositories/benefits/fairs.repository';
import { create } from 'zustand';

import { FairType } from 'src/types/fair';

type States = {
  loadingFairList: boolean;
  loadingFairDetails: boolean;
  loadingFairCreate: boolean;
  loadingFairUpdate: boolean;
  fairList: FairType[];
  fairDetails: FairType | null;
};

type Actions = {
  getFairList: () => Promise<void>;
  getFairDetails: (id: string) => Promise<void>;
  resetFairDetails: () => Promise<void>;
  createFair: (fair: any) => Promise<void>;
  updateFair: (id: string, fair: any) => Promise<void>;
};

type Store = Actions & States;

const initialValues = {
  loadingFairList: false,
  loadingFairDetails: false,
  loadingFairCreate: false,
  loadingFairUpdate: false,
  fairList: [],
  fairDetails: null,
};

const repository = new FairsRepository(makeBenefitsApi());

export const useFairStore = create<Store>((set) => ({
  ...initialValues,

  getFairList: async () => {
    set({ loadingFairList: true });
    const response = await repository.getFairList();
    if (response.isLeft()) {
      set({ fairList: [], loadingFairList: false });
      throw new Error(response.value.message);
    }
    set({
      fairList: response.value,
      loadingFairList: false
    });
  },

  getFairDetails: async (id: string) => {
    set({ loadingFairDetails: true });
    const response = await repository.getFairDetails(id);
    if (response.isLeft()) {
      set({ fairDetails: null, loadingFairDetails: false });
      throw new Error(response.value.message);
    }
    set({
      fairDetails: response.value,
      loadingFairDetails: false
    });
  },

  resetFairDetails: async () => set({ fairDetails: null }),

  createFair: async (fair: any) => {
    set({ loadingFairCreate: true });
    const response = await repository.createFair(fair);
    if (response.isLeft()) {
      set({ loadingFairCreate: false });
      throw new Error(response.value.message);
    }
    set({
      loadingFairCreate: false
    });
  },

  updateFair: async (id: string, fair: any) => {
    set({ loadingFairUpdate: true });
    const response = await repository.updateFair(id, fair);
    if (response.isLeft()) {
      set({ loadingFairUpdate: false });
      throw new Error(response.value.message);
    }
    set({
      loadingFairUpdate: false
    });
  },

}));
